module.exports = __webpack_public_path__ + "img/dropsSlots_900.0609a2f7.png";